import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import './index.css';
import App from './App';
import Callback from './Callback';
import ProjectManagement from './components/ProjectManagement';
import Sidebar from './components/Sidebar';
import Build from './components/modules/Build';
import Test from './components/modules/Test';
import Deploy from './components/modules/Deploy';
import DatasetManagement from './components/modules/DatasetManagement';
import SyntheticDataset from './components/modules/SyntheticDataset';
import Evaluation from './components/modules/Evaluation';
import EvaluationDetails from './components/modules/EvaluationDetails';
import ProjectDetails from './components/modules/ProjectDetails';
import Usage from './components/modules/Usage';
import Logs from './components/modules/Logs';
import './components/ProjectManagement.css';
import reportWebVitals from './reportWebVitals';

const createWrapper = (Component: React.ComponentType<any>, activeModule: 'project' | 'build' | 'test' | 'deploy' | 'usage' | 'logs') => {
  return () => {
    const { projectId } = useParams<{ projectId: string }>();
    return (
      <div className="project-management">
        <Sidebar projectId={projectId || ''} activeModule={activeModule} />
        <div className="main-content">
          <Component projectId={projectId || ''} />
        </div>
      </div>
    );
  };
};

const ProjectWrapper = createWrapper(ProjectDetails, 'project');
const BuildWrapper = createWrapper(Build, 'build');
const TestWrapper = createWrapper(Test, 'test');
const DeployWrapper = createWrapper(Deploy, 'deploy');
const UsageWrapper = createWrapper(Usage, 'usage');
const LogsWrapper = createWrapper(Logs, 'logs');
const DatasetWrapper = createWrapper(DatasetManagement, 'test');
const EvaluationWrapper = createWrapper(Evaluation, 'test');

const EvaluationDetailsWrapper = () => {
  const { projectId } = useParams<{ projectId: string }>();
  return (
    <div className="project-management">
      <Sidebar projectId={projectId || ''} activeModule="test" />
      <div className="main-content">
        <EvaluationDetails />
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/project/:projectId" element={<ProjectWrapper />} />
        <Route path="/project/:projectId/usage" element={<UsageWrapper />} />
        <Route path="/project/:projectId/logs" element={<LogsWrapper />} />
        <Route path="/project/:projectId/build" element={<BuildWrapper />} />
        <Route path="/project/:projectId/test" element={<TestWrapper />} />
        <Route path="/project/:projectId/deploy" element={<DeployWrapper />} />
        <Route path="/project/:projectId/test/dataset" element={<DatasetWrapper />} />
        <Route path="/project/:projectId/test/dataset/synthetic" element={<SyntheticDataset />} />
        <Route path="/project/:projectId/test/evaluation" element={<EvaluationWrapper />} />
        <Route path="/project/:projectId/test/evaluation/:evalRunId" element={<EvaluationDetailsWrapper />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
